import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgNupay = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 31 17" aria-labelledby={titleId} {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M5.798 1.86C6.746.896 8.005.333 9.483.333c2.88 0 4.79 2.033 5.155 5.078.119.99.117 2.383.116 3.998v6.554h-3.96v-4.475s-.009-3.83-.033-4.545c-.106-3.117-2.015-5.076-4.964-5.078-.89.909-1.366 2.02-1.436 3.718-.01.237-.007 1.076-.004 2.183l.004 1.889c.003 2.916 0 6.308 0 6.308H.4V9.077c0-.236-.005-.474-.01-.713-.009-.48-.018-.965.01-1.444.044-.8.187-1.585.573-2.315.883-1.673 2.693-2.75 4.622-2.75.068 0 .135.002.202.005ZM30.364 9.747c.027-.48.018-.963.009-1.444-.005-.239-.01-.477-.01-.713V.704h-3.96s-.003 3.392 0 6.308c0 .67.003 1.316.004 1.889.003 1.107.006 1.946-.004 2.183-.07 1.699-.547 2.81-1.436 3.718-2.949-.002-4.858-1.96-4.964-5.078-.024-.715-.034-2.491-.034-4.548V.7L16.01.705v6.553c-.002 1.615-.002 3.009.116 3.998.364 3.045 2.274 5.078 5.154 5.078 1.479 0 2.737-.563 3.686-1.527.066.003.134.004.201.004 1.93 0 3.74-1.076 4.622-2.749.386-.73.53-1.515.574-2.315Z"
    />
  </svg>
);
export default SvgNupay;
